import { Error } from '@unimed-fesp/components';
import React from 'react';
import { useLocation } from 'react-router-dom';
import history from '../../services/history';

function ErrorPage() {
  const location = useLocation();
  const props = location.state;

  function handleClick() {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const queryUrlRedirect = params.get('redirect');
    if (props) {
      history.push(props.path);
    }
    if (queryUrlRedirect) history.push(queryUrlRedirect);
    else window.location.reload();
  }

  const errorNumber = '500';
  const errorTitle = 'oops! erro do servidor interno';
  const errorMessage =
    'O servidor encontrou uma situação com a qual não sabe lidar.';

  if (props) {
    return (
      <Error
        onReaload={handleClick}
        httpCode={props.error}
        title={props.title}
        message={props.message}
      />
    );
  }

  return (
    <Error
      onReaload={handleClick}
      httpCode={errorNumber}
      title={errorTitle}
      message={errorMessage}
    />
  );
}

export default ErrorPage;
